<template>
  <LayoutDefault>
    <ProjectsList />
  </LayoutDefault>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import ProjectsList from '@/components/blocks/ProjectsList.vue'

export default {
  name: 'HomeView',
  components: {
    LayoutDefault,
    ProjectsList
  },
  setup () {
    const store = useStore()
    const routerLocation = computed(() => router.options.history.location)

    onMounted(() => {
      if (routerLocation.value !== '/auth') {
        store.dispatch('setAuthenticatedData')
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
